import type { FC } from 'react';
import { Container, Content, InvaliadImage, Message, Wrapper } from './style';

const CheckDevicePage: FC = () => {
  return (
    <Container>
      <Wrapper>
        <Content>
          <InvaliadImage src={'/img/invalid_page.png'} />
          <Message>
            카메라 또는 마이크의 연결 상태를 확인해 주시기 바랍니다.
            <br />
            서비스 이용 중 동일한 현상이 반복될 경우
            <br />
            관리자 또는 고객센터에 문의해 주시기 바랍니다.
          </Message>
        </Content>
      </Wrapper>
    </Container>
  );
};

export default CheckDevicePage;
